import classNames from 'classnames/bind';
import React, { FunctionComponent } from 'react';

import { TextBgType } from '../../typings';
import styles from './highlighted-field.module.scss';

const cx = classNames.bind(styles);

export interface IHighlightedFieldProps {
  content: string;
  bgColor: TextBgType;
}

export const HighlightedField: FunctionComponent<IHighlightedFieldProps> = props => {
  const { content, bgColor } = props;

  const classNames = cx(styles.highlightedField, {
    [`bg_${bgColor}`]: bgColor !== 'transparent'
  });

  return (
    <>
      <div
        className={classNames}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </>
  );
};
